var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Base class for all adapters.
 * Provides onReady queueing and a default transform method.
 */
var GenericAdapter = /** @class */ (function () {
    function GenericAdapter() {
        this.readyQueue = [];
    }
    GenericAdapter.prototype.broadcastReady = function () {
        this.isReady = true;
        this.readyQueue.forEach(function (cb) { return cb(); });
        this.readyQueue = [];
    };
    GenericAdapter.prototype.onReady = function (cb) {
        if (this.isReady)
            cb();
        this.readyQueue.push(cb);
    };
    /**
     * Default transformer; merges a Hive defined event with enhanced object.
     */
    GenericAdapter.prototype.transform = function (obj, enhanced) {
        return __assign(__assign({}, obj), enhanced);
    };
    return GenericAdapter;
}());
export { GenericAdapter };
